import React from 'react';
import queryString from 'query-string';
import { Form, Progress, Alert } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.svg';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'cnp';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();
    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });


    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value,
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div className="login-cnp-container text-align-center" ref={this.ref}>
          <div className="login-cnp-header">
            <img src={logo} alt="logo" className="logo-cnp rounded mx-auto d-block" />
          </div>
          <div className="login-cnp-body">
            <div className="text-align-center" style={{ marginBottom: '20px' }}>
              <h1 className="cnp-title">INICIA SESIÓN</h1>
            </div>
            <Form onSubmit={event => this.onSubmit(event)}>
              <div className="row">
                <div className="col-xs-12 col-md-12 col-lg-3" style={{ textAlign: 'left' }}>
                  <label style={{ fontSize: '12px' }}>Correo electrónico:</label>
                </div>
                <div className="col-xs-12 col-md-12 col-lg-9">
                  <input
                    className="user-input-cnp"
                    disabled={this.state.onLogin}
                    ref={(ref) => this.usernameInput = ref}
                    required={true}
                    tabIndex={1}
                    type="email"
                    autoCorrect="off"
                    autoCapitalize="none"
                    name="username"
                  />
                </div>
              </div>
              <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-xs-12 col-md-12 col-lg-3" style={{ textAlign: 'left' }}>
                  <label style={{ fontSize: '12px' }}>Contraseña:</label>
                </div>
                <div className="col-xs-12 col-md-12 col-lg-9">
                  <input
                    className="user-input-cnp"
                    required={true}
                    disabled={this.state.onLogin}
                    ref={(ref) => this.passwordInput = ref}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    name="password"
                  />
                </div>
              </div>

              <div className="row" style={{ marginTop: '30px' }}>
                <div className="col-xs-4 col-md-4 col-lg-4"></div>
                <div className="col-xs-4 col-md-4 col-lg-4">
                  {!this.state.onLogin ?
                    <div>
                      <button
                        block={!this.parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-cnp"
                        type="submit"
                        name="submit"
                        disabled={!this.props.turnstileSuccess}
                      >
                        Ingresar
                      </button>
                    </div>
                    :
                    <Progress animated color="danger" value={100} />
                  }
                </div>
                <div className="col-xs-4 col-md-4 col-lg-4"></div>
              </div>


              <div style={{ marginTop: '20px' }}>
                <p class="cnp-text">¿Olvidaste tu contraseña? <a href="https://www.cinepolisklic.com/recuperar-password" class="link" target="_blank" rel="noopener noreferrer">Da clic aquí</a>.</p>
                {
                  checkDeviceIOS() ? '' : <p class="cnp-text">¿No tienes una cuenta en Cinépolis KLIC<sup>®</sup>? Regístrate GRATIS <a href="https://www.cinepolisklic.com/registrarse" class="link" target="_blank" rel="noopener noreferrer">aquí</a>.</p>

                }
                <br />
                <p class="cnp-text">¿Necesitas ayuda? Visita <a href="https://www.cinepolisklic.com/ayuda" class="link" target="_blank" rel="noopener noreferrer">www.cinepolisklic.com/ayuda</a></p>
                <p class="cnp-text">O comunícate a cualquiera de nuestros teléfonos 2122-6060 y 01-55-2122-6060</p>
              </div>
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={this.state.error.open} toggle={() => this.setState({ error: { open: false } })}>
                  {this.state.error.message}
                </Alert>
              </div>
            </Form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm));
